import { gql } from '@apollo/client';

export const QUERY = gql`
  query CoordinatedDivisions($organizationId: Int!) {
    coordinatedDivisions(organizationId: $organizationId) {
      id
      name
      season {
        id
        name
        fullName
        program {
          id
          name
        }
      }
      linkInfo {
        rootDivisionId
        divisionId
      }
    }
  }
`;
